const shared = {
    background: {
        default: {
            dark: "rgb(250, 250, 250)",
            light: "rgb(48, 48, 48)",
        },
        paper: {
            dark: "rgb(255, 255, 255)",
            light: "rgb(66, 66, 66)",
        },
    },
};
const mcdColors = {
    primary: {
        dark: "#fbbc0e",
        light: "#264F36",
    },
    secondary: {
        dark: "#fbbc0e",
        light: "#fbbc0e",
    },
    background: shared.background,
};
const inaColors = {
    primary: {
        dark: "#004c97",
        light: "#004c97",
    },
    secondary: {
        dark: "#e63036",
        light: "#e63036",
    },
    background: shared.background,
};
const piasColors = {
    primary: {
        dark: "#3D4A6E",
        light: "#3D4A6E",
    },
    secondary: {
        dark: "#397478",
        light: "#397478",
    },
    background: shared.background,
};
const infinityColors = {
    primary: {
        dark: "#5B665A",
        light: "#B6C2AF",
    },
    secondary: {
        dark: "#B89F86",
        light: "#E3D8C7",
    },
    background: shared.background,
};
const eleportColors = {
    primary: {
        dark: "#1EA538",
        light: "#1EA538",
    },
    secondary: {
        dark: "#000",
        light: "#000",
    },
    background: shared.background,
};
const qeloColors = {
    primary: {
        dark: "#0063AF",
        light: "#0063AF",
    },
    secondary: {
        dark: "#8BC63F",
        light: "#8BC63F",
    },
    background: shared.background,
};
const defaultColors = {
    primary: {
        dark: "#254092",
        light: "#90caf9",
    },
    secondary: {
        dark: "#4caf50",
        light: "#4caf50",
    },
    background: shared.background,
};
export const colors = process.env.APP_ID === "mcd"
    ? mcdColors
    : process.env.APP_ID === "ina"
        ? inaColors
        : process.env.APP_ID === "pias"
            ? piasColors
            : process.env.APP_ID === "infinity"
                ? infinityColors
                : process.env.APP_ID === "eleport"
                    ? eleportColors
                    : process.env.APP_ID === "qelo"
                        ? qeloColors
                        : defaultColors;
export const metricColors = [
    "66, 84, 251",
    "255, 180, 34",
    "250, 79, 88",
    "13, 190, 255",
    "34, 191, 117",
    "250, 131, 180",
    "255, 117, 17",
];
